import { setRangeMax } from './helpers';

export const setFloorMax = setRangeMax('floor');
